const envPrefix = "REACT_APP_";

/**
 * @param {string} name
 * @return {string}
 */
export const getEnvValue = (name: string): string =>
  process.env[envPrefix + name] || "";
